<div id="container" class="effect aside-float aside-bright mainnav-lg">
    <div class="app-loader" style="display: none;">
        <div class="loader-container">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83 82">
                <title>Pague.Lá</title>
                <defs>
                    <radialGradient id="etapa1" cx="129" cy="131.67" r="330.65" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stop-color="#00f6ff" />
                        <stop offset="0.07" stop-color="#20c7ff" />
                        <stop offset="0.16" stop-color="#4099ff" />
                        <stop offset="0.25" stop-color="#5c70ff" />
                        <stop offset="0.34" stop-color="#744dff" />
                        <stop offset="0.44" stop-color="#8731ff" />
                        <stop offset="0.55" stop-color="#961bff" />
                        <stop offset="0.67" stop-color="#a10cff" />
                        <stop offset="0.8" stop-color="#a703ff" />
                        <stop offset="1" stop-color="#a900ff" />
                        <animate attributeName="r" dur="2s" values="330; 530; 330;" repeatCount="indefinite" />
                    </radialGradient>
                </defs>
                <g id="b6656d4b-1f1c-4fd6-a35b-b6b92d61acff" data-name="Camada 1">
                    <path d="M47.93,0C22.35,0,12.44,4.71,6.18,21.47,2.51,31.42.42,47.13.42,54.46c0,12.26,4.82,18.65,14.18,21.68L26.76,22.33c.9-4.59,3.9-7.28,9.84-7.28H47.22c12.34,0,18.86,3.83,18.21,16.66-.92,18.18-11.51,25.17-27.3,25.17H36.31c-3.54,0-4.65,1.06-5,3.06L26.56,78.25c2.74.2,5.69.29,8.84.29,24,0,32.88-3.14,39.67-14.66,5.22-9.95,7.83-26.71,7.83-40.32C82.9,6.81,74.55,0,47.93,0Zm5.33,31.9c.3-6-2.85-7.94-8.4-7.94s-5.93,0-6.92,4.39L34.59,43.58a21.15,21.15,0,0,0-.29,2.1c-.1,2,.94,2.3,4,2.3C48.43,48,52.75,42.15,53.27,31.9Z" class="objeto-logo-paguela" style="fill:#0094ff" />
                </g>
            </svg>
        </div>
    </div>
    <div class="boxed">
        <div id="content-container">
            <header>
                <div class="breadcrumb">
                    <span class="page-title">{{routeTitle}}</span>
                    <span class="page-path">
                        <span>/ </span><span *ngFor="let path of paths"><a [routerLink]="path.link">{{path.breadcrumb}}</a><span *ngIf="path.children"> / </span></span>
                    </span>
                </div>
            </header>
            <router-outlet></router-outlet>
        </div>
        <app-side-menu></app-side-menu>
        <app-navbar></app-navbar>
    </div>
</div>

<app-footer></app-footer>

<button class="scroll-top btn">
    <i class="pci-chevron chevron-up"></i>
</button>

<app-modal-detail class="modal-info" [showModal]="showModal" (eventClose)="eventClose()">
  <app-register *ngIf="account" [conta]="account"></app-register>
</app-modal-detail>

<app-modal-detail *ngIf="!showModal" [showModal]="showModalPayment">
  <div class="modal-detail-container hide-modal-detail">
    <div class="modal-detail">
      <div class="cls-content-lg panel" style="border: none; border-bottom: none; box-shadow: none;">
        <div class="panel-body secoes">
          <div class="secao secao-1 informacoes-cadastrais">
            <h3 style="text-align: center">Você possui débitos em aberto!</h3>
            <h4 style="font-weight: normal; text-align: center;" class="mb-40">Para regularizar sua conta, emita sua fatura.</h4>
          </div>

          <!-- <div class="row btns">
            <div class="btn-next" animate="fadeIn" delay="900">
              <button (click)="goToFatura()" class="btn btn-primary btn-registrar" type="submit">Ver Fatura</button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="modal-detail-mask"></div>
  </div>
</app-modal-detail>
